module.exports = __webpack_public_path__ + "static/media/logoClientes.5e4edfcd.jpg";